import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { Icon, notification, Modal, Button, Collapse, Select } from "antd";

import DrawerDataEmissao from "../../Aproveitamento/Relatorios/Drawer/Ata";
import ModalViewer from "../../../shared/components/Modals/ModalViewer";
import ModalLoading from "../../../shared/components/Modals/ModalLoading";
import DrawerAdicionarParecer from "../Drawers/DrawerAdicionarParecer";
import ModalGerarDocumento from "../../../shared/components/Modals/GerarDocumento";
import InitialsAvatar from "../../../shared/components/InitialsAvatar";

import axios from "axios";
import { useEffect } from "react";

import { GlobalContext } from "../../../app/providers/GlobalState";

const { Option } = Select;
const { Panel } = Collapse;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const TurmaPareceres = ({ match }) => {
    const [num, setNum] = useState(1);
    const [totalPeriodos, setTotalPeriodos] = useState(0);
    const [disciplinaId, setDisciplinaId] = useState([]);
    const [listaDisciplinas, setListaDisciplinas] = useState([]);
    const [periodos, setPeriodos] = useState([]);
    const [periodo, setPeriodo] = useState({
        id: null,
        titulo: "",
        dtInicio: "",
        dtFim: ""
    });
    const [tituloParecer, setTituloParecer] = useState("");
    const [tituloParecerGeral, setTituloParecerGeral] = useState("");
    const [textoParecerGeral, setTextoParecerGeral] = useState("");
    const [drawerAdicionarParecerVisible, setDrawerAdicionarParecerVisible] = useState(false);
    const [parecer, setParecer] = useState({});
    const [participantes, setParticipantes] = useState([]);
    const [docs, setDocs] = useState([]);
    const [ficheiroExportar, setFicheiroExportar] = useState("");
    const [btnDescarregar, setBtnDescarregar] = useState(false);
    const [visibleExportar, setVisibleExportar] = useState(false);
    const [dataEmissaoAlunoVisible, setDataEmissaoAlunoVisible] = useState(false);
    const [dataEmissaoGeralAlunosVisible, setDataEmissaoGeralAlunosVisible] = useState(false);
    const [dataEmissaoGeralVisible, setDataEmissaoGeralVisible] = useState(false);
    const [visibleViewer, setVisibleViewer] = useState(false);
    const [semPeriodos, setSemPeriodos] = useState(false);
    const [iconLoading, setIconLoading] = useState(false);
    const [visibleLoading, setVisibleLoading] = useState(false);
    const [alunoId, setAlunoId] = useState();

    const context = useContext(GlobalContext);

    const total = () => {
        setIconLoading(true);

        axios({
            method: "get",
            url: "/api/aulas/total-periodos-observacoes",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                if (response.data.length > 0) {
                    setTotalPeriodos(response.data.length);
                    setPeriodos(response.data);
                    setPeriodo({
                        id: response.data[0].id,
                        titulo: response.data[0].titulo,
                        dtInicio: response.data[0].dt_inicio,
                        dtFim: response.data[0].dt_fim
                    });
                } else {
                    setSemPeriodos(true);
                    setIconLoading(false);

                    openNotificationWithIcon("warning", "Atenção", "Não foram adicionados períodos ao curso!");
                }
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar a aula!");
            });
    };

    const carregarDisciplinas = () => {
        axios({
            method: "get",
            url: "/api/pareceres/carregar-disciplinas",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setListaDisciplinas(response.data);
                setIconLoading(false);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os pareceres!");
            });
    };

    const carregarListaPareceres = turmaId => {
        axios({
            method: "get",
            url: "/api/pareceres/carregar-pareceres",
            params: {
                turmaId,
                periodoId: periodo.id
            }
        })
            .then(response => {
                const { participantes, textoParecerGeral } = response.data;

                let disciplinas = listaDisciplinas;
                let disciplina = disciplinas.find(d => d.id == turmaId);

                disciplina = {
                    ...disciplina,
                    participantes,
                    textoParecerGeral
                };

                disciplinas = [...disciplinas.filter(d => d.id != turmaId), disciplina].sort(
                    (a, b) => listaDisciplinas.findIndex(x => x.id === a.id) - listaDisciplinas.findIndex(x => x.id === b.id)
                );

                setListaDisciplinas(disciplinas);
                setIconLoading(false);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os pareceres!");
            });
    };

    const tituloPareceres = () => {
        axios({
            method: "get",
            url: "/api/pareceres/titulo-parecer",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setTituloParecer(response.data.parecer);
                setTituloParecerGeral(response.data.parecerGeral);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar o parecer geral!");
            });
    };

    const anteriorProximo = num => {
        var periodo = periodos[num - 1];

        setNum(num);
        setPeriodo({
            id: periodo.id,
            titulo: periodo.titulo,
            dtInicio: periodo.dt_inicio,
            dtFim: periodo.dt_fim
        });
        setIconLoading(true);
    };

    const guardar = () => {
        carregarListaPareceres(disciplinaId);
    };

    const descarregarParecerDescritivoTurma = dataEmissao => {
        setBtnDescarregar(true);
        setVisibleExportar(true);

        axios({
            method: "get",
            url: "/api/pdf/parecer-descritivo-turma",
            params: {
                utilizadorId: alunoId,
                turmaId: disciplinaId,
                periodoId: periodo.id,
                dataEmissao: dataEmissao.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                setBtnDescarregar(false);
                setFicheiroExportar(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível descarregar o documento!");

                setVisibleExportar(false);
            });
    };

    const exportarParecerGeralAlunos = dataEmissao => {
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/parecer-descritivo-alunos-geral",
            params: {
                turmaId: disciplinaId,
                periodoId: periodo.id,
                dataEmissao: dataEmissao?.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setVisibleLoading(false);
                setVisibleViewer(true);
                setDocs([{ uri: url, fileName }]);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");

                setVisibleLoading(false);
            });
    };

    const exportarGeraisPdf = dataEmissao => {
        setVisibleLoading(true);

        axios({
            method: "get",
            url: "/api/pdf/parecer-descritivo-turma-geral",
            params: {
                turmaId: disciplinaId,
                periodoId: periodo.id,
                dataEmissao: dataEmissao?.format("YYYY-MM-DD")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setVisibleLoading(false);
                setVisibleViewer(true);
                setDocs([{ uri: url, fileName }]);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");

                setVisibleLoading(false);
            });
    };

    const carregarPareceres = key => {
        if (key.length > 0) {
            carregarListaPareceres(key[0]);
        }
    };

    useEffect(() => {
        total();
        tituloPareceres();
        carregarDisciplinas();
    }, []);

    useEffect(() => {
        if (periodo.id) {
        }
    }, [periodo]);

    const acesso = context.acessos?.find(x => x.func === 30);

    return (
        <>
            <div className="container container-body">
                <div className="bloco-curso-diario-opcoes" style={{ gap: 10 }}>
                    <h3 className="titulo-bloco">Pareceres</h3>
                    <div className="bloco-opcoes-esquerda">
                        <Link
                            to={`/gerir-detalhe-turma/${match.params.turma}/${
                                localStorage.getItem("vista") === "TURMA" ? "horario" : "horario-disciplina"
                            }`}
                            className="botao-secundario botao-secundario-redondo"
                            title="Voltar"
                            style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                        >
                            <Icon type="arrow-left" />
                        </Link>
                    </div>
                </div>
                <div className="curso-diario">
                    <div className="bloco-controlos-frequencia">
                        <div className="filters" style={{ display: "flex", justifyContent: "center" }}>
                            {!semPeriodos && (
                                <div>
                                    <Button
                                        className="botao-periodo botao-periodo-anterior"
                                        disabled={num === 1}
                                        style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                        onClick={() => anteriorProximo(num - 1)}
                                    >
                                        <Icon type="left" />
                                    </Button>
                                    <span>{periodo.titulo}</span>
                                    <Button
                                        className="botao-periodo botao-periodo-proximo"
                                        disabled={num === periodos.length}
                                        style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                        onClick={() => anteriorProximo(num + 1)}
                                    >
                                        <Icon type="right" />
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                    {listaDisciplinas.map(disciplina => (
                        <div>
                            <Collapse defaultActiveKey={[]} className="collapse-diario-observacoes" onChange={carregarPareceres}>
                                <Panel
                                    header={<label style={{ fontSize: 16, cursor: "pointer" }}>{disciplina.nome}</label>}
                                    key={disciplina.id}
                                >
                                    <Collapse defaultActiveKey={[]} className="collapse-diario-observacoes">
                                        <Panel
                                            header={
                                                <span
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <label style={{ cursor: "pointer" }}>{tituloParecer}</label>
                                                    <span style={{ display: "flex", gap: 10 }}>
                                                        <Link
                                                            className="botao-icon-detalhe"
                                                            to="#"
                                                            title="Visualizar"
                                                            onClick={event => {
                                                                event.stopPropagation();
                                                                setDisciplinaId(disciplina.id);

                                                                if (localStorage.getItem("entidade_id") === "33") {
                                                                    setDataEmissaoGeralAlunosVisible(true);
                                                                } else {
                                                                    exportarParecerGeralAlunos();
                                                                }
                                                            }}
                                                        >
                                                            <Icon type="eye" />
                                                        </Link>
                                                    </span>
                                                </span>
                                            }
                                            key="1"
                                        >
                                            <div className="bloco-diario-observacoes">
                                                <ul className="lista-observacoes">
                                                    {disciplina.participantes?.map(participante => (
                                                        <li key={participante.id} className="item-observacoes">
                                                            <div
                                                                className="info-participante"
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center"
                                                                }}
                                                            >
                                                                <div className="container-img">
                                                                    {participante.foto ? (
                                                                        <img src={participante.foto} />
                                                                    ) : (
                                                                        participante.nome !== "" && (
                                                                            <InitialsAvatar name={participante.nome} />
                                                                        )
                                                                    )}
                                                                </div>
                                                                <div className="info" style={{ flex: "fit-content" }}>
                                                                    <span className="nome">{participante.nome}</span>
                                                                    <p className="numero">{participante.numero}</p>
                                                                </div>
                                                                <div className="bloco-opcoes-esquerda" style={{ display: "flex", gap: 5 }}>
                                                                    {acesso?.update && (
                                                                        <Link
                                                                            to="#"
                                                                            className="botao-icon-editar"
                                                                            title="Editar"
                                                                            onClick={event => {
                                                                                event.stopPropagation();
                                                                                setDrawerAdicionarParecerVisible(true);
                                                                                setDisciplinaId(disciplina.id);
                                                                                setParecer({
                                                                                    participante
                                                                                });
                                                                            }}
                                                                        >
                                                                            <Icon type="edit" />
                                                                        </Link>
                                                                    )}
                                                                    <Link
                                                                        className="botao-icon-parecer-aluno"
                                                                        to="#"
                                                                        title="Visualizar"
                                                                        onClick={event => {
                                                                            event.stopPropagation();
                                                                            setAlunoId(participante.id);
                                                                            setDisciplinaId(disciplina.id);
                                                                            setDataEmissaoAlunoVisible(true);
                                                                        }}
                                                                    >
                                                                        <Icon type="profile" />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <p dangerouslySetInnerHTML={{ __html: participante.parecer }}></p>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </Panel>
                                        <Panel
                                            header={
                                                <span
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <label>{tituloParecerGeral}</label>
                                                    <span style={{ display: "flex", gap: 10 }}>
                                                        {acesso?.update && (
                                                            <Link
                                                                to="#"
                                                                className="botao-icon-editar"
                                                                title="Editar"
                                                                onClick={event => {
                                                                    event.stopPropagation();
                                                                    setDrawerAdicionarParecerVisible(true);
                                                                    setDisciplinaId(disciplina.id);
                                                                    setParecer({
                                                                        textoParecerGeral: disciplina.textoParecerGeral
                                                                    });
                                                                }}
                                                            >
                                                                <Icon type="edit" />
                                                            </Link>
                                                        )}
                                                        <Link
                                                            className="botao-icon-detalhe"
                                                            to="#"
                                                            title="Visualizar"
                                                            onClick={event => {
                                                                event.stopPropagation();
                                                                setDisciplinaId(disciplina.id);

                                                                if (localStorage.getItem("entidade_id") === "33") {
                                                                    setDataEmissaoGeralVisible(true);
                                                                } else {
                                                                    exportarGeraisPdf();
                                                                }
                                                            }}
                                                        >
                                                            <Icon type="eye" />
                                                        </Link>
                                                    </span>
                                                </span>
                                            }
                                            key="2"
                                        >
                                            <div className="bloco-diario-observacoes">
                                                {disciplina.textoParecerGeral ? (
                                                    <p
                                                        className="observacao-geral"
                                                        dangerouslySetInnerHTML={{ __html: disciplina.textoParecerGeral }}
                                                    ></p>
                                                ) : (
                                                    <p className="observacao-geral">Sem dados...</p>
                                                )}
                                            </div>
                                        </Panel>
                                    </Collapse>
                                </Panel>
                            </Collapse>
                        </div>
                    ))}
                </div>
            </div>
            <Modal visible={iconLoading} maskClosable={false} className="modal-loading" footer={null} closable={false}>
                <div className="modal-loading-bloco">
                    <p>
                        <Icon type="loading" />
                    </p>
                    <p className="texto">A carregar...</p>
                </div>
            </Modal>
            <ModalGerarDocumento
                visibleExportar={visibleExportar}
                ficheiroExportar={ficheiroExportar}
                btnDescarregar={btnDescarregar}
                onClose={() => setVisibleExportar(false)}
            />
            <ModalLoading visible={visibleLoading} text="A gerar documento..." />
            <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => setVisibleViewer(false)} />
            <DrawerDataEmissao
                visible={dataEmissaoAlunoVisible}
                onClose={() => setDataEmissaoAlunoVisible(false)}
                onConfirm={dataEmissao => {
                    descarregarParecerDescritivoTurma(dataEmissao);
                    setDataEmissaoAlunoVisible(false);
                }}
            />
            <DrawerDataEmissao
                visible={dataEmissaoGeralAlunosVisible}
                onClose={() => setDataEmissaoGeralAlunosVisible(false)}
                onConfirm={dataEmissao => {
                    exportarParecerGeralAlunos(dataEmissao);
                    setDataEmissaoGeralAlunosVisible(false);
                }}
            />
            <DrawerDataEmissao
                visible={dataEmissaoGeralVisible}
                onClose={() => setDataEmissaoGeralVisible(false)}
                onConfirm={dataEmissao => {
                    exportarGeraisPdf(dataEmissao);
                    setDataEmissaoGeralVisible(false);
                }}
            />
            <DrawerAdicionarParecer
                disciplinaId={disciplinaId}
                parecerInfo={parecer}
                periodoId={periodo.id}
                visible={drawerAdicionarParecerVisible}
                onClose={() => setDrawerAdicionarParecerVisible(false)}
                onConfirm={() => {
                    guardar();
                    setDrawerAdicionarParecerVisible(false);
                }}
            />
        </>
    );
};

export default TurmaPareceres;
